
// ROUTES
require('modules/hotel/routes/hotel');

// CONTROLLERS
require('modules/hotel/controllers/hotel');
require('modules/hotel/controllers/list');
require('modules/hotel/controllers/create');
require('modules/hotel/controllers/edit');

// SERVICES
require('modules/hotel/services/hotel');
require('modules/hotel/services/list');
require('modules/hotel/services/create');
require('modules/hotel/services/edit');
require('modules/hotel/services/delete');


angular.module('unica_hotel', [

	'uiGmapgoogle-maps',

	// ROUTES
	'unica_hotel.hotel_routes',

	// CONTROLLERS
	'unica_hotel.hotel_controllers',

	// SERVICES
	'unica_hotel.hotel_services'

]);